// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectPrice_wrapper__LUT8E","buttons":"ProjectPrice_buttons__PnpQc","inputs":"ProjectPrice_inputs__j3NHr"};